// extracted by mini-css-extract-plugin
export default {"container":"WL-z","modal":"XL-z","dimensions":"YL-z","brandName":"ZL-z","productName":"_L-z","recipientEmail":"aM-z","recommendedFit":"bM-z","hiddenField":"cM-z"};